export const SITE = {
  name: "Thrive Bridge Mental Wellness CIC",
  short: "Thrive Bridge",
  tagline: "Mental health and wellbeing support",
  email: "hello@thrivebridge.org.uk",
  phone: "01782 901354",
  phoneRaw: "01782901354",
  address: "321–323 High Road, Chadwell Heath, Essex RM6 6AX, UK",
  hours: "Mon–Fri · 9:30 – 17:30",
  socials: {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://linkedin.com/",
    twitter: "https://x.com/",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Who We Help", to: "/who-we-help" },
  { label: "Partners", to: "/partners" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "peer-support",
    title: "Peer Support Groups",
    icon: "Users",
    short: "Reducing isolation through shared experience.",
    description:
      "Small groups where people with similar experiences meet, listen and support one another. Facilitated by trained peers.",
  },
  {
    slug: "wellbeing-workshops",
    title: "Wellbeing Workshops",
    icon: "Sprout",
    short: "Practical tools for emotional resilience.",
    description:
      "Sessions on stress, sleep, grounding, healthy relationships and managing difficult emotions.",
  },
  {
    slug: "one-to-one-support",
    title: "One-to-One Support",
    icon: "MessageCircleHeart",
    short: "Individual support sessions.",
    description:
      "Confidential sessions with a trained wellbeing practitioner, focused on what matters most to you.",
  },
  {
    slug: "outreach",
    title: "Outreach & Engagement",
    icon: "HandHeart",
    short: "Reaching those most at risk.",
    description:
      "We visit community hubs, shelters, places of worship and food banks so support is easier to access.",
  },
];

export const AUDIENCES = [
  {
    title: "People affected by migration and displacement",
    body: "Whether you've recently arrived in the UK or settled long ago, we offer support in a way that respects your background and language.",
    icon: "Globe2",
  },
  {
    title: "Survivors of violence and abuse",
    body: "Trauma-informed support at your pace. You set the boundaries.",
    icon: "Shield",
  },
  {
    title: "People experiencing homelessness or poverty",
    body: "Practical support that recognises housing and money worries directly affect mental health.",
    icon: "Home",
  },
  {
    title: "Individuals facing social exclusion",
    body: "If you've felt let down or unheard by services before, we want to do things differently.",
    icon: "Users",
  },
];

export const TEAM = [
  { name: "Amara Okonkwo", role: "Founding Director", bio: "Mental health practitioner and community organiser." },
  { name: "Rohan Patel", role: "Head of Services", bio: "Trauma-informed care lead with NHS background." },
  { name: "Layla Ahmadi", role: "Peer Support Lead", bio: "Lived experience advocate and group facilitator." },
  { name: "Daniel Mensah", role: "Outreach Coordinator", bio: "Building bridges with grassroots communities." },
];

export const PARTNERS = [
  "London Borough Council",
  "Local Housing Association",
  "Jobcentre Plus",
  "NHS Community Mental Health",
  "Refuge UK",
  "Community Food Bank",
];

export const POSTS = [
  {
    slug: "welcoming-our-first-peer-group",
    title: "Welcoming our first community peer support group",
    date: "2025-09-12",
    category: "Community News",
    excerpt:
      "This month we opened the doors to our first peer support circle — a quiet, brave beginning shaped by the people in the room.",
    image:
      "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&w=1200",
  },
  {
    slug: "five-grounding-techniques",
    title: "Five grounding techniques you can use anywhere",
    date: "2025-10-04",
    category: "Wellbeing Tips",
    excerpt:
      "When the world feels too loud, these simple grounding practices can help you return to your body and the present moment.",
    image:
      "https://images.unsplash.com/photo-1643012177761-cc4949dfa8ba?crop=entropy&cs=srgb&fm=jpg&w=1200",
  },
  {
    slug: "thank-you-funders",
    title: "Thank you to our first funders and partners",
    date: "2025-11-21",
    category: "Organisation Updates",
    excerpt:
      "A heartfelt thank you to the local authorities, voluntary organisations and individual donors making this work possible.",
    image:
      "https://images.unsplash.com/photo-1694286080661-f44117e019ed?crop=entropy&cs=srgb&fm=jpg&w=1200",
  },
];
